import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
// import { useEffect, useState } from 'react';
import { APP_IMG } from 'src/constants';
import styled from 'styled-components';
// import DynamicAds, { KEY_ADS_TYPE } from '../ads/dynamic-ads';
const HeaderComponent = ({ headerLeft, headerRight, headerCenter, headerPage, linkCenter, headerPartnerPage, headerLeftStar, linkPartnerPage, textHeader, headerPartner, linkPartner }) => {
  const router = useRouter();
  // const [isSpecialPath, setIsSpecialPath] = useState(false);

  // useEffect(() => {
  //   setIsSpecialPath(router?.query?.cid === 'KA5' || router?.query?.cid === 'KA8');
  // }, [router?.query?.cid, router?.pathname]);
  return (
    <>
      <HeadWrapper center={!isEmpty(headerCenter)} >
        <div className='flex-header'>
        <a href='https://www.komchadluek.net/' rel='noopener noreferrer' target='_blank' >
         <img className='logo-brand' src={`${APP_IMG}/images/logo-web/komchadluek-logo-04.webp?x-image-process=style/md-webp`} alt='logo-brand' />
        </a>

        {headerLeft && (
          <HeaderWrapper className='--left' logo={headerLeftStar} >
            <a href={router?.query?.location ? `/${router?.query?.location}` : '/'} target='_self'>
              <img
                className='logo --left'
                src={headerLeft}
                alt='logo-1'
                width='100%'
                height='100%'
              />
            </a>
          </HeaderWrapper>
        )}
        {headerPartner && (
            <HeaderWrapper className='--partner' logo={headerPartner} >
            <a href={linkPartner} rel='noopener noreferrer' target='_blank' >
              <img
                className='logo --partner'
                src={headerPartner}
                alt='logo-1'
                width='100%'
                height='100%'
              />
            </a>
        </HeaderWrapper>
        )}
        </div>
        {
          headerCenter && (
            <HeaderWrapper className='--center' >
            {linkCenter
              ? <a href={linkCenter} rel='noopener noreferrer' target='_blank' >
              <img
              className='logo --center'
              src={headerCenter}
              alt='vote'
              width='100%'
              height='100%'
            />
          </a>

              : <img
              className='logo --center'
              src={headerCenter}
              alt='vote'
              width='100%'
              height='100%'
            />}
          </HeaderWrapper>
          )
        }
        {headerRight && (
          <HeaderWrapper className='--right' >
            <img
              className='logo --right'
              src={headerRight}
              alt='vote'
              width='100%'
              height='100%'
            />
              {textHeader && <div className='title-wrapper'>
                  <span> {textHeader} </span>
                </div>}
          </HeaderWrapper>
        )}
        { headerPage && <div className='flex-header'>

            <HeaderWrapper className='--page' logo={headerPage} >
              <a href={router?.query?.location ? `/${router?.query?.location}` : '/'} target='_self'>
                <img
                  className='logo --page'
                  src={headerPage}
                  alt='logo-1'
                  width='100%'
                  height='100%'
                />
              </a>
            </HeaderWrapper>
          {headerPartnerPage && (
              <HeaderWrapper className='--partner-page' logo={headerPartnerPage} >
              <a href={linkPartnerPage} rel='noopener noreferrer' target='_blank' >
                <img
                  className='logo --partner-page'
                  src={headerPartnerPage}
                  alt='logo-1'
                  width='100%'
                  height='100%'
                />
              </a>
          </HeaderWrapper>
          )}
          </div>}
      </HeadWrapper>
    </>
  );
};

const HeadWrapper = styled.header`
display: grid;
margin: auto;
width: 100%;
height: 900px;
max-width: 1600px;
grid-template-columns:${({ center }) => (center === true ? '1fr 2fr 1fr' : '1fr 1fr')};
.logo-brand {
  position: absolute;
  max-width: 100px;
  top: 20px;
  left: 20px;
}
@media (min-width: 2000px) {
  height: 1400px;

}
@media (max-width: 1200px) {
  height: 600px;

}
@media (max-width: 1024px) {
  height: 500px;

}

@media (max-width: 768px) {
  display: block;
  height: 400px;
  align-items: flex-start;
  justify-content: space-between;
}
@media (max-width:475px) {
  height: 300px;

}
@media (max-width:375px) {
  height: 200px;

}
.flex-header {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const HeaderWrapper = styled.div`
text-align: center;

&.--partner {
  display: flex;
align-items:center;
  max-width: 100%;
  width: 100%;
  justify-content: flex-start;
  @media (max-width: 768px) {
    width:  50%;
  } 
  a {
    width: 100%;
  
  }
  img {
    width:   '100%';
  }
}
&.--center {
    width: 65%;
    justify-content: center;
    display: flex;
    margin: auto;
    padding-top: 50px;
    @media (max-width: 768px) {
      width: 80%;

    }
}
&.--right {
  width: 100%;

  justify-content: center;
  align-items: center;
  display: flex;
  margin: auto;
  /* width: ${({ cus }) => (cus === true ? '70%' : '100%')};  */
  width: '100%'; 

  padding: 0 30px;
  /* mix-blend-mode: ${({ cus }) => (cus === true ? 'normal' : 'screen')};  */
  mix-blend-mode:  'screen';
  @media (max-width: 768px) {
   margin-left: auto;
    margin-right: auto;
    width: 80%;
    margin-top: 20px;
  }
 
}

&.--left {
    justify-content: center;
    align-items: center;
    display: flex;
    /* width:  ${({ cus }) => ((cus === true) ? '70%' : '100%')}; ;
    padding-top: ${({ cus }) => (cus === true ? '0px' : '20px')}; 
    mix-blend-mode: ${({ cus }) => (cus === true ? 'normal' : 'screen')};  */
    width:  '100%' ;
    padding-top:  '20px'; 
    mix-blend-mode: 'screen'; 


    @media (max-width: 768px) {

    width: 50%;
    margin:  auto;               
    }

  }
 .title-wrapper {
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;   
    text-align: center;
    width: 100%;
    font-size: 3.5em;
    line-height: 1em;
    font-weight: 500;
    letter-spacing: 3px;
    padding-top: 30px;
    padding-bottom: 30px;
    text-shadow: 5px 2px 5px rgb(34 34 34 / 70%);
    @media (max-width: 768px) {
      font-size: 2em;
      padding-top: 10px;

    }
    @media (max-width: 478px) {
      font-size: 1em;
      padding-top: 10px;

    }
  }
  .logo {
    width: 100%;
    margin: auto;
    height: auto;
&.--partner-page , &.--page {
  max-width: 600px;
  @media (max-width: 768px) {
    max-width: 150px;
  }
}
@media (max-width: 768px) {
padding-top   : 2rem ;
}
  }
`;
export default HeaderComponent;
